export enum brandingTypes {
    FETCH_BRANDING_REQUEST = 'FETCH_BRANDING_REQUEST',
    UPDATE_BRANDING_REQUEST = 'UPDATE_BRANDING_REQUEST',
    SET_BRANDING = 'SET_BRANDING',
}
